import { Instagram, Mail } from "lucide-react";
import { fileUrl } from "../../lib/cta";
import CurrencySwitcher from "./CurrencySwitcher";

export default function Footer({ data, brand }) {
  const logoUrl = fileUrl(brand?.logo);
  return (
    <footer data-testid="footer-section" className="bg-onyx text-alabaster py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-serif text-2xl mb-3">{brand.name}</h3>
            <p className="text-alabaster/60 text-sm">{data.tagline}</p>
            {logoUrl && (
              <img
                data-testid="footer-logo"
                src={logoUrl}
                alt={brand.name}
                className="mt-6 w-24 h-24 object-cover rounded-sm border border-alabaster/10"
              />
            )}
          </div>
          <div>
            <p className="overline text-gold mb-4">Contato</p>
            <ul className="space-y-2 text-sm text-alabaster/70">
              {data.email && (
                <li className="flex items-center gap-2">
                  <Mail size={14} />
                  <a href={`mailto:${data.email}`} className="hover:text-gold">{data.email}</a>
                </li>
              )}
              {data.instagram && (
                <li className="flex items-center gap-2">
                  <Instagram size={14} />
                  <span>{data.instagram}</span>
                </li>
              )}
            </ul>
          </div>
          <div>
            <p className="overline text-gold mb-4">Links</p>
            <ul className="space-y-2 text-sm text-alabaster/70">
              {(data.links || []).map((l, i) => (
                <li key={i}>
                  <a href={l.url} className="hover:text-gold transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-gold transition-colors text-xs opacity-60">
                  Painel Admin
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-alabaster/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-alabaster/50">
          <span>{data.copyright}</span>
          <div className="flex items-center gap-3">
            <span className="text-alabaster/30">Moeda:</span>
            <CurrencySwitcher variant="footer" />
          </div>
        </div>
      </div>
    </footer>
  );
}
